import { Component, OnInit, Input,Output } from '@angular/core';

export class ASelectInfo {
    id: number;
    label : string;
    name: string;
    text: string;
    placeholder : string;
    support : string;
    minlength: number;
    maxlength: number;
  }

  @Component({
    selector: 'select-ttt',
    templateUrl: './a-select.component.html',
})
export class ASelectComponent implements OnInit {
    @Input() selectdata: number;
    @Input() info: any;
    @Input() nullselect:boolean;
    @Input() main_language_flg:number;

    constructor() { }

    ngOnInit() {
    }
}


// WEBPACK FOOTER //
// ./src/app/a0103-question-register/a-select.component.ts